// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { messageBot16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-message-bot': IconMessageBot;
    }
}

/**
 * The icon component for the 'messageBot' icon
 */
export class IconMessageBot extends IconSvg {
    public constructor() {
        super(messageBot16X16);
    }
}

registerIconSvg('icon-message-bot', IconMessageBot);
export const iconMessageBotTag = 'nimble-icon-message-bot';
